import React, { useState, useEffect } from 'react'
import { getUserNotification } from '../../Web Apis/Apis'
import Loader from '../Loader/Loader'
import { message } from 'antd'
import { MdCancel } from "react-icons/md";

function ViewNotifications({ selectedUser, showNotificationModal, setShowNotificationModal }) {
    const [open, setOpen] = useState(showNotificationModal)
    const [loading, setLoading] = useState(false)
    const [notifications, setNotifications] = useState([])

    const fetchUserNotification = async () => {
        try {
            setLoading(true)
            const response = await getUserNotification(selectedUser)
            if (response?.data?.success) {
                setNotifications(response?.data?.data)
                console.log("ajay", response.data.data)
            }
        } catch (error) {
            console.log("Admin fetch error", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.clear();
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchUserNotification()
    }, [])


    const closeEditModal = () => {
        setShowNotificationModal(false)
        setOpen(false)
        setNotifications([])
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] overflow-y-auto">

                <div className="relative flex items-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 px-4 text-white">
                    <h3 className="absolute left-1/2 transform -translate-x-1/2 text-xl font-bold">
                        User Notifications
                    </h3>

                    <button onClick={closeEditModal} className="ml-auto text-red-500 hover:text-red-700">
                        <MdCancel className="text-3xl" />
                    </button>
                </div>



                {/* <div className="flex justify-end gap-6 mt-2 mr-2">
                    <button onClick={closeEditModal} className="bg-gray-300 border border-gray-800 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                        Close
                    </button>

                </div> */}
                <table className='min-w-full mt-2 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
                    <thead>
                        <th className="py-2 px-4 border-b text-center">S.No</th>
                        <th className="py-2 px-4 border-b text-center">Title</th>
                        <th className="py-2 px-4 border-b text-center">Body</th>
                        {/* <th className="py-2 px-4 border-b text-center">Actions</th> */}
                    </thead>
                    <tbody>
                        {notifications?.length > 0 ? (
                            notifications?.map((data, index) => (
                                <tr key={data.id}
                                    className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                                >
                                    <td className='py-2 px-4 border-b'>{index + 1}</td>
                                    <td className="py-2 px-4 border-b">{data.title}</td>
                                    <td className="py-2 px-4 border-b">{data.body}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No notifications data found</td>
                            </tr>
                        )}


                    </tbody>


                        {loading && <Loader/>}
                </table>


            </div>
        </div>
    )
}

export default ViewNotifications